import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetCompanionSessionQuery,
  GetCompanionSessionQueryVariables,
} from "./GetCompanionSession.generated";

export const GET_COMPANION_SESSION: TypedDocumentNode<
  GetCompanionSessionQuery,
  GetCompanionSessionQueryVariables
> = gql`
  query getCompanionSession($companionSessionUuid: String!) {
    companionSession(companionSessionUuid: $companionSessionUuid) {
      companionSessionUuid
      createdAt
      updatedAt
      title
      statusText
      summary
      sessionType
      messages {
        companionSessionMessageUuid
        role
        createdAt
        textContent
        companionType
      }
      attachments {
        uuid
        fileName
      }
      tasks {
        companionSessionTaskUuid
        name
        createdAt
        updatedAt
        status
        taskStepDescription
      }
    }
  }
`;
export default GET_COMPANION_SESSION;
